export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=401fa5c9db7e9af674c17ec607ad00b01b9e75b1be&name=revalidateCommunity!'